import React from 'react';
import { Link } from 'react-router-dom';

// Shown at the top of a record that was created by converting another
// record (e.g. a Sales Order converted from an Accepted Quote — see
// vis_sales_orders.md's Convert entry point) — sibling to DuplicateBanner,
// same visual shell, but persistent (based on a stored FK) rather than tied
// to unsaved local state, since a conversion is a permanent fact about the
// record rather than something that stops being true once saved.
function ConvertedBanner({ title, message, linkTo, linkLabel }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 14,
        padding: '14px 20px',
        marginBottom: 18,
        background: '#fff',
        border: '1px solid #e3e7ee',
        borderBottom: '3px solid #1976d2',
        borderRadius: 8,
      }}
    >
      <span
        style={{
          flexShrink: 0,
          width: 26,
          height: 26,
          borderRadius: '50%',
          background: '#d92d20',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 15,
        }}
      >
        !
      </span>
      <div>
        <div style={{ fontWeight: 700, fontSize: 16 }}>{title}</div>
        <div style={{ marginTop: 4, fontSize: 14, color: '#333' }}>
          {message}{' '}
          <Link to={linkTo} style={{ color: '#1976d2', textDecoration: 'underline' }}>{linkLabel}</Link>
        </div>
      </div>
    </div>
  );
}

export default ConvertedBanner;
